/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import { CustomTheme, greyMultibrandPalette } from '@masfront/common-b2c'

import {
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { getTypeText, getOriginText } from '~/balance/helpers/balance.helpers'
import { Recharge } from '~/balance/model/balance.model'
import { formatFee, formatDate } from '~/utils'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    root: {
      maxHeight: '500px',
      border: `1px solid ${greyMultibrandPalette[200]}`,
      borderRadius: theme.spacing(3.5),
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    tableHead: {
      backgroundColor: greyMultibrandPalette[50],
    },
  }
})

interface RechargesHistoryTableProps {
  recharges: Recharge[]
}

const RechargesHistoryTable: React.FC<RechargesHistoryTableProps> = ({ recharges }) => {
  const classes = useStyles()

  return (
    <TableContainer className={classes.root}>
      <Table data-hook="recharges-table" stickyHeader>
        <TableHead>
          <TableRow className={classes.tableHead}>
            <TableCell>
              <Typography variant="h6">FECHA</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">HORA</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">TIPO SOLICITUD</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">ORIGEN</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">REFERENCIA</Typography>
            </TableCell>
            <TableCell>
              <Typography variant="h6">IMPORTE</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recharges.map((singleRecharge, i) => (
            <TableRow key={singleRecharge.id} data-hook={`recharges-row-${i}`}>
              <TableCell>
                <Typography variant="h5">
                  {formatDate(singleRecharge.date, 'dd/MM/yyyy')}
                </Typography>
              </TableCell>
              <TableCell>{formatDate(singleRecharge.date, 'HH:mm')}</TableCell>
              <TableCell>
                <Typography variant="body2">{getTypeText(singleRecharge.type)}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{getOriginText(singleRecharge.origin)}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{singleRecharge.id}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h5">{formatFee(singleRecharge.amount)}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default RechargesHistoryTable
